(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pandora-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pauseMarkup =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14"></path><path d="M16 5v14"></path></svg>';
    const playMarkup =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m8 5 10 7-10 7z"></path></svg>';
    const muteMarkup =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 14h4l5 4V6L8 10H4z"></path><path d="M16.5 8.5 20 15.5"></path><path d="M20 8.5 16.5 15.5"></path></svg>';
    const volumeMarkup =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 14h4l5 4V6L8 10H4z"></path><path d="M17 9.25a4.25 4.25 0 0 1 0 5.5"></path><path d="M18.75 7a7.25 7.25 0 0 1 0 10"></path></svg>';

    const createMediaManager = () => {
      const mediaQuery = window.matchMedia("(max-width: 989px)");
      let frame = 0;

      const getPanels = () => Array.from(document.querySelectorAll("[data-pd-media-panel]"));
      const getVideo = (panel) => panel?.querySelector("[data-pd-responsive-video]");

      const updateControls = (panel) => {
        const video = getVideo(panel);
        if (!video) return;

        const scope = panel.parentElement;
        const playButton = scope.querySelector("[data-pd-toggle-play]");
        const muteButton = scope.querySelector("[data-pd-toggle-mute]");
        const playIcon = scope.querySelector("[data-pd-play-icon]");
        const muteIcon = scope.querySelector("[data-pd-mute-icon]");

        if (playButton) {
          playButton.setAttribute("aria-pressed", video.paused ? "true" : "false");
          playButton.setAttribute("aria-label", video.paused ? "Play background media" : "Pause background media");
        }

        if (muteButton) {
          muteButton.setAttribute("aria-pressed", video.muted ? "true" : "false");
          muteButton.setAttribute("aria-label", video.muted ? "Unmute background media" : "Mute background media");
        }

        if (playIcon) playIcon.innerHTML = video.paused ? playMarkup : pauseMarkup;
        if (muteIcon) muteIcon.innerHTML = video.muted ? muteMarkup : volumeMarkup;
      };

      const ensureSource = (video) => {
        const desktopSource = video.dataset.desktopSrc || "";
        const mobileSource = video.dataset.mobileSrc || desktopSource;
        const nextSource = mediaQuery.matches ? mobileSource || desktopSource : desktopSource || mobileSource;
        if (!nextSource) return false;

        if (video.dataset.activeSrc !== nextSource) {
          video.pause();
          video.dataset.ready = "false";
          video.dataset.activeSrc = nextSource;
          video.src = nextSource;
          video.load();
        }

        return true;
      };

      const getTopScene = () => {
        if (!document.elementsFromPoint) return null;
        const x = Math.max(1, Math.min(window.innerWidth - 1, window.innerWidth / 2));
        const y = Math.max(1, Math.min(window.innerHeight - 1, window.innerHeight / 2));
        const selector = ".pd-home-hero, .pd-home-category-split, .pd-feature-banner, .pd-home-benefits, .pd-home-footer";

        for (const element of document.elementsFromPoint(x, y)) {
          const scene = element.closest?.(selector);
          if (scene) return scene;
        }

        return null;
      };

      const bindPanel = (panel) => {
        if (!panel || panel.dataset.pdPanelBound === "true") return;
        const video = getVideo(panel);
        if (!video) return;

        panel.dataset.pdPanelBound = "true";
        video.muted = true;

        const scope = panel.parentElement;
        const playButton = scope.querySelector("[data-pd-toggle-play]");
        const muteButton = scope.querySelector("[data-pd-toggle-mute]");

        const markReady = () => {
          video.dataset.ready = "true";
          updateControls(panel);
        };

        video.addEventListener("loadeddata", markReady);
        video.addEventListener("playing", markReady);
        video.addEventListener("pause", () => updateControls(panel));
        video.addEventListener("volumechange", () => updateControls(panel));
        video.addEventListener("error", () => {
          video.dataset.ready = "false";
          updateControls(panel);
        });

        if (playButton) {
          playButton.addEventListener("click", async () => {
            if (video.paused) {
              panel.dataset.pdUserPaused = "false";
              if (ensureSource(video)) await video.play().catch(() => undefined);
            } else {
              panel.dataset.pdUserPaused = "true";
              video.pause();
            }
            updateControls(panel);
          });
        }

        if (muteButton) {
          muteButton.addEventListener("click", () => {
            video.muted = !video.muted;
            updateControls(panel);
          });
        }

        updateControls(panel);
      };

      const sync = () => {
        frame = 0;
        const scene = document.hidden ? null : getTopScene();
        const activePanel = scene?.querySelector("[data-pd-media-panel]") || null;

        getPanels().forEach((panel) => {
          bindPanel(panel);
          const video = getVideo(panel);
          if (!video) return;

          if (panel !== activePanel) {
            if (!video.paused) video.pause();
            updateControls(panel);
            return;
          }

          if (ensureSource(video) && panel.dataset.pdUserPaused !== "true" && video.paused && video.dataset.playPending !== "true") {
            video.dataset.playPending = "true";
            video.play().catch(() => undefined).finally(() => {
              video.dataset.playPending = "false";
              updateControls(panel);
            });
          }

          updateControls(panel);
        });
      };

      const schedule = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(sync);
      };

      const resetSources = () => {
        getPanels().forEach((panel) => {
          const video = getVideo(panel);
          if (!video) return;
          video.pause();
          video.removeAttribute("src");
          video.removeAttribute("data-active-src");
          video.dataset.ready = "false";
          video.load();
        });
        schedule();
      };

      window.addEventListener("scroll", schedule, { passive: true });
      window.addEventListener("resize", schedule, { passive: true });
      document.addEventListener("visibilitychange", schedule);
      document.addEventListener("shopify:section:load", schedule);

      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener("change", resetSources);
      } else {
        mediaQuery.addListener(resetSources);
      }

      return {
        refresh() {
          getPanels().forEach(bindPanel);
          schedule();
        },
      };
    };

    if (!window.__pdHomeMediaManager) {
      window.__pdHomeMediaManager = createMediaManager();
    }
    window.__pdHomeMediaManager.refresh();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pandora-site-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindHeader = (root) => {
      if (!root || root.dataset.pdShellBound === "true") return;
      root.dataset.pdShellBound = "true";

      const cartCountNodes = Array.from(root.querySelectorAll("[data-pd-cart-count]"));
      const drawer = root.querySelector("[data-pd-drawer]");
      const drawerButton = root.querySelector("[data-pd-drawer-button]");
      const closeTargets = root.querySelectorAll("[data-pd-drawer-close]");

      const applyCartCount = (count) => {
        cartCountNodes.forEach((node) => {
          node.dataset.count = String(count);
          node.textContent = String(count);
          node.hidden = count < 1;
        });
      };

      const syncCartCount = async (count = null) => {
        if (typeof count === "number" && Number.isFinite(count)) {
          applyCartCount(Math.max(0, count));
          return;
        }

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
            headers: { Accept: "application/json" },
            credentials: "same-origin",
          });
          if (!response.ok) return;
          const data = await response.json();
          applyCartCount(Number(data?.item_count || 0));
        } catch {}
      };

      syncCartCount();
      document.addEventListener("cart:update", (event) => {
        const nextCount = Number(event?.detail?.resource?.item_count);
        if (Number.isFinite(nextCount)) {
          syncCartCount(nextCount);
        } else {
          syncCartCount();
        }
      });
      document.addEventListener("shopify:cart:lines-update", (event) => {
        if (!event?.promise || typeof event.promise.then !== "function") {
          syncCartCount();
          return;
        }

        event.promise
          .then(({ cart, detail }) => {
            const nextCount = Number(cart?.totalQuantity ?? detail?.itemCount);
            if (Number.isFinite(nextCount)) {
              syncCartCount(nextCount);
            } else {
              syncCartCount();
            }
          })
          .catch(() => syncCartCount());
      });

      if (!drawer || !drawerButton) return;

      const closeDrawer = () => {
        drawer.hidden = true;
        drawer.removeAttribute("data-open");
        drawerButton.setAttribute("aria-expanded", "false");
        document.documentElement.removeAttribute("data-pd-drawer-open");
      };

      drawerButton.addEventListener("click", () => {
        const willOpen = drawer.hidden;
        drawer.hidden = !willOpen;
        if (willOpen) {
          drawer.setAttribute("data-open", "true");
          drawerButton.setAttribute("aria-expanded", "true");
          document.documentElement.setAttribute("data-pd-drawer-open", "true");
        } else {
          closeDrawer();
        }
      });

      closeTargets.forEach((target) => {
        target.addEventListener("click", closeDrawer);
      });

      drawer.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", closeDrawer);
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && !drawer.hidden) closeDrawer();
      });
    };

    document.querySelectorAll("[data-pd-header-shell]").forEach(bindHeader);
    document.addEventListener("shopify:section:load", (event) => {
      bindHeader(event.target?.querySelector?.("[data-pd-header-shell]"));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
